<!-- ======= Intro Section ======= -->
<section id="intro">
  <div class="intro-container">
    <div id="introCarousel" class="carousel slide carousel-fade" data-ride="carousel">

      <ol class="carousel-indicators"></ol>

      <div class="carousel-inner" role="listbox">

        <div class="carousel-item active" style="background-image: url(../../assets/images/image1.jpg)">
          <div class="carousel-container">
            <div class="container">
              <div class="row">
                <div class="col-md-12 text-left">
                  <div class="pagerow1 animate__animated animate__fadeInUp">
                    <span style="margin-left: 0px;">Beyond Compliance</span>
                  </div>
                  <div class="pagerow2 animate__animated animate__fadeInDown">
                    <span style="margin-left: 10px;">Built on Excellence</span>
                  </div>
                  <!-- <div class="pagerow3 animate__animated animate__fadeInDown">
                    <span style="margin-left: 10px;">and Training</span>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="carousel-item" style="background-image: url(../../assets/images/image2.jpg)">
          <div class="carousel-container">
            <div class="container">
              <div class="row animate__animated animate__fadeInUp">
                <div class="col-md-8">

                </div>
                <div class="col-md-4">
                  <div class="page2row1">
                    <p>
                      As an integral part of a <br /><span><b style="font-weight: 700;">Complete Safety
                          Program,</b></span> our safety inspections go Beyond Compliance by identifying hazards, reducing risk, and helping prevent injuries and accidents before they occur.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="carousel-item" style="background-image: url(../../assets/images/image3.jpg)">
          <div class="carousel-container">
            <div class="container">
              <div class="row animate__animated animate__fadeInUp">
                <div class="col-md-12">
                  <div class="page2row1">
                    <p>
                      Through training you can provide your employees the tools to go  <br /><span><b
                          style="font-weight: 700;">Beyond Compliance and help build a safer, stronger workplace</b></span>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a class="carousel-control-prev" href="#introCarousel" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon fa fa-chevron-left" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>

      <a class="carousel-control-next" href="#introCarousel" role="button" data-slide="next">
        <span class="carousel-control-next-icon fa fa-chevron-right" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>

    </div>
  </div>
</section>
<!-- End Intro Section -->

<!-- ======= Our Portfolio Section ======= -->
<section id="portfolio" class="portfolio section-bg">
  <div class="container" data-aos="fade-up" data-aos-delay="300">

    <div class="section-title">
      <header class="section-header">
        <h2>Welcome to <strong style="font-weight: bolder;">SFI Safety</strong></h2>
        <h3></h3>
      </header>
      <p class="theme_color">SFI brings more than 150 years of combined workplace safety and risk management 
        experience, recognized industry expertise, extensive bilingual capabilities, 
        and advanced professional certifications. Our consultants help organizations go Beyond
        Compliance through OSHA support, Risk Management, On-Site Safety Evaluations, Safety Program Development and Review, 
        and practical Safety Training designed to strengthen performance and safety culture.</p>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <ul id="portfolio-flters">
          <!-- <li data-filter="*" style="visibility: hidden;">All</li> -->
          <li [ngClass]="{'filter-active':IsProgram===true}" (click)="isotopeFilter('program')"><i
              class="fa fa-bullhorn"></i>&nbsp;Safety Programs</li>
          <li (click)="isotopeFilter('training')" [ngClass]="{'filter-active':IsTraining==true}"><i
              class="fa fa-graduation-cap"></i>&nbsp;Safety Training</li>
          <li (click)="isotopeFilter('inspection')" [ngClass]="{'filter-active':IsInspection==true}"><i
              class="fa fa-file-text"></i>&nbsp;Safety Inspections</li>
        </ul>
      </div>
    </div>

    <!-- <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'200px'"
      *ngIf="safetyProgram.length===0 && safetyTraining.length===0 && safetyInspection.length===0">
    </ngx-shimmer-loading> -->


    <div class="row portfolio-container"
      *ngIf="safetyProgram!==null && safetyTraining!==null && safetyInspection!==null">

      <div class="col-lg-4 col-md-6 portfolio-item filter-program" *ngFor="let sd of safetyProgram;index as i;"
        [ngClass]="{'showfolio':IsProgram===true,'hidefolio':IsProgram===false}">
        <div class="portfolio-wrap">
          <!-- <img [src]="'data:image/png;base64,'+sd.MarketingImage" style="width: 100%;height:260px;" class="img-fluid"
            alt="" /> -->

            <img [src]="sd.homeimage" style="width: 100%;height:260px;" class="img-fluid"
            alt="" />

          <div class="card-body">
            <span class="theme_color"><strong><u>{{sd.heading}}</u></strong></span>
            <p class="card-text">{{sd.description}}</p>
          </div>
          <a href="{{sd.link}}">
            <div class="portfolio-info">
              <img src="../../assets/images/hat-icon.png" alt="" class="img-fluid" /><br />
              <span class="clickstyle"><i><u>Click to know more about</u></i></span>
              <span class="clickstyle clickfontsize">{{sd.heading}}</span>
            </div>
          </a>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 portfolio-item filter-card" *ngFor="let st of safetyTraining;index as i;"
        [ngClass]="{'showfolio':IsTraining===true,'hidefolio':IsTraining===false}">
        <div class="portfolio-wrap">
          <!-- <img [src]="'data:image/png;base64,'+st.MarketingImage" style="width: 100%;height:260px;" class="img-fluid"
            alt="" /> -->
          <img [src]="st.homeimage" style="width: 100%;height:260px;" class="img-fluid"
            alt="" />

          <div class="card-body">
            <span class="theme_color"><strong><u>{{st.heading}}</u></strong></span>
            <p class="card-text">{{st.description}}</p>
          </div>

          <a href="{{st.link}}">
            <div class="portfolio-info">
              <img src="../../assets/images/hat-icon.png" alt="" class="img-fluid" /><br />
              <span class="clickstyle"><i><u>Click to know more about</u></i></span>
              <span class="clickstyle clickfontsize">{{st.heading}}</span>
            </div>
          </a>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 portfolio-item filter-web" *ngFor="let sd of safetyInspection;index as i;"
        [ngClass]="{'showfolio':IsInspection==true,'hidefolio':IsInspection===false}">
        <div class="portfolio-wrap">
          <!-- <img [src]="'data:image/png;base64,'+sd.MarketingImage" class="img-fluid" style="width: 100%;height:260px;"
            alt="" /> -->
          <img [src]="sd.homeimage" class="img-fluid" style="width: 100%;height:260px;"
            alt="" />

          <div class="card-body">
            <span class="theme_color"><strong><u>{{sd.heading}}</u></strong></span>
            <p class="card-text">{{sd.description}}</p>
          </div>

          <a href="{{sd.link}}">
            <div class="portfolio-info">
              <img src="../../assets/images/hat-icon.png" alt="" class="img-fluid" /><br />
              <span class="clickstyle"><i><u>Click to know more about</u></i></span>
              <span class="clickstyle clickfontsize">{{sd.heading}}</span>
            </div>
          </a>
        </div>
      </div>
    </div>

  </div>
</section><!-- End Our Portfolio Section -->

<!-- section Mission Statement -->

<section class="section layout_padding" style="background-color: #F2F3F5;">
  <div class="container" data-aos="fade-up" data-aos-delay="300">
    <div class="section-title">
      <header class="section-header">
        <h2>Our <strong style="font-weight: bolder;">Mission</strong></h2>
        <h3></h3>
      </header>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <img class="img-fluid" src="../../assets/images/Mission-image.png" alt="Mission Image" />
        <div>
          <h3 class="theme_color" style="color: gray;">We work hard to improve lives and empower
            <strong class="theme_color">America's workforce</strong> to return home <i><b>Safely Each Day</b></i>.
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- end section -->


<!-- ======= Recent News Section ======= -->
<section id="news" class="news section-bg" style="background-color: #f8f9fb;" *ngIf="false">
  <div class="container" data-aos="fade-up" data-aos-delay="300">

    <div class="section-title">
      <header class="section-header">
        <h2><strong style="font-weight: bolder;">Recent News</strong></h2>
        <h3></h3>
      </header>
      <p class="theme_color">.</p>
    </div>

    <ngx-skeleton-loader count="5" appearance="line" *ngIf="recentNews.length===0"></ngx-skeleton-loader>
    

    <!-- <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'200px'" *ngIf="recentNews.length===0">
    </ngx-shimmer-loading> -->
  </div>
</section><!-- End Recent News Section -->


<!-- ======= Counts Section ======= -->
<section *ngIf="false" class="counts section-bg" style="background-color: #E4E3E8;" data-aos="fade-up" data-aos-delay="100">
  <div class="container">

    <div class="row">

      <div class="col-lg-4 col-md-6 text-center" data-aos="fade-up" data-aos-delay="100">
        <div class="count-box">
          <img src="../../assets/images/people-icon.png" alt="" /><br />
          <span [countUp]="48" [options]="cOpt">48</span>
          <p class="theme_color">Hardworking People</p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 text-center" data-aos="fade-up" data-aos-delay="300">
        <div class="count-box">
          <img src="../../assets/images/states-icon.png" alt="" /><br />
          <span [countUp]="28" [options]="cOpt">28</span>
          <p class="theme_color">States Covered</p>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 text-center" data-aos="fade-up" data-aos-delay="500">
        <div class="count-box">
          <img src="../../assets/images/100-years.png" alt="" /><br />
          <span [countUp]="100" [options]="cOpt">100</span>
          <p class="theme_color">Over 100 Years of Experience</p>
        </div>
      </div>
    </div>
  </div>
</section><!-- End Counts Section -->

<!--Slider-->
<swiper-container [config]="configSwiper" id="sfiswiper" class="testimonials">
  <div class="swiper-wrapper">
    <div class="swiper-slide" *ngFor="let fb of feedbacks">
      <div class="container">
        <div class="row testimonial-item">
          <div class="col-md-12 text-center">
            <label [ngClass]="fb.rating>0?'fa fa-star checked':'fa fa-star'" class="stars"></label>
            <label [ngClass]="fb.rating>0 && fb.rating>1?'fa fa-star checked':'fa fa-star'" class="stars"></label>
            <label [ngClass]="fb.rating>0 && fb.rating>2?'fa fa-star checked':'fa fa-star'" class="stars"></label>
            <label [ngClass]="fb.rating>0 && fb.rating>3?'fa fa-star checked':'fa fa-star'" class="stars"></label>
            <label [ngClass]="fb.rating>0 && fb.rating>4?'fa fa-star checked':'fa fa-star'" class="stars"></label>
            <h3 *ngIf="fb.name!==''">{{fb.name}}</h3>
            <h4 *ngIf="fb.designaton!==''">{{fb.designation}}</h4>
            <p *ngIf="fb.description!==''">
              <i class="bx bxs-quote-alt-left quote-icon-left"></i>
              {{fb.description}}
              <i class="bx bxs-quote-alt-right quote-icon-right"></i>
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- Add Pagination -->
  <!-- <div class="swiper-pagination mt-10" ></div> -->
  <!-- Add Arrows -->
  <div class="swiper-button-next"></div>
  <div class="swiper-button-prev"></div>
</swiper-container>
<!--end slider-->